export default __webpack_public_path__ + "static/media/greeting9.f238dda7.png";